import React from "react";

/**
 * Renders the four-step progress header (Password → Information → Payment → Signature).
 */
const VendorOnboardingStepIndicator = ({
  step1,
  category,
  stepPayment,
  stepSignature,
}) => (
  <div className="bg-light rounded-3 p-3 mb-3">
    <div className="steps pt-4 pb-1">
      <div className={step1 ? "step active" : ""}>
        <div className="step-progress">
          <span className="step-progress-start"></span>
          <span className="step-progress-end"></span>
          <span className="step-number">1</span>
        </div>
        <div className="step-label">Password</div>
      </div>
      <div
        className={
          category && !stepPayment && !stepSignature ? "step active" : ""
        }
      >
        <div className="step-progress">
          <span className="step-progress-start"></span>
          <span className="step-progress-end"></span>
          <span className="step-number">2</span>
        </div>
        <div className="step-label">Information</div>
      </div>
      <div className={stepPayment ? "step active" : ""}>
        <div className="step-progress">
          <span className="step-progress-start"></span>
          <span className="step-progress-end"></span>
          <span className="step-number">3</span>
        </div>
        <div className="step-label">Payment</div>
      </div>
      <div className={stepSignature ? "step active" : ""}>
        <div className="step-progress">
          <span className="step-progress-start"></span>
          <span className="step-progress-end"></span>
          <span className="step-number">4</span>
        </div>
        <div className="step-label">Acknowledgment & Signature</div>
      </div>
    </div>
  </div>
);

export default VendorOnboardingStepIndicator;
